/**
 * 模型思考档规格（N-130 E1）——会话发送、输入框思考档弹层、设置页「行内配置」三处只读这一份。
 *
 * 业务白话：同一个模型不论走企业网关还是个人订阅，「推荐档」都一样——超管平台对该模型的配置
 * （企业版含组织覆盖，与网关行同一份值），没配就用厂商默认；员工自己选过就用员工的。
 * 推荐档与员工档都会**显式发送**，界面标「推荐」的就是实际发出去的那一档（展示 = 调用）。
 *
 * 企业约束（按模型可选范围、全局上限）只收窄企业网关模型；个人订阅与员工自建接入点
 * （`isPersonalWalletGroup`）不受约束——维护者 2026-10-14 拍板「订阅模式支持用户在 app 内设置」。
 */
import { nearestSupportedEffort } from "./model-registry.js";
import { THINKING_LEVELS, sortByThinkingLevel } from "./types/index.js";
const LEVEL_SET = new Set(THINKING_LEVELS);
function isThinkingLevel(value) {
    return LEVEL_SET.has(value);
}
/** 不可信输入（设置 / IPC / 清单 defaults 里的 `"auto"` 等）→ ThinkingLevel；词表外一律 undefined。 */
export function parseThinkingLevel(raw) {
    if (typeof raw !== "string")
        return undefined;
    const value = raw.trim();
    return isThinkingLevel(value) ? value : undefined;
}
function rank(level) {
    return THINKING_LEVELS.indexOf(level);
}
export function resolveModelEffortSpec(input) {
    let levels = sortByThinkingLevel([...new Set((input.supportedLevels ?? []).filter((level) => isThinkingLevel(level)))]);
    if (!input.personalWallet) {
        if (input.enterpriseAllowed && input.enterpriseAllowed.length > 0) {
            const allowed = new Set(input.enterpriseAllowed);
            levels = levels.filter((level) => allowed.has(level));
        }
        if (input.enterpriseMax) {
            const cap = rank(input.enterpriseMax);
            levels = levels.filter((level) => rank(level) <= cap);
        }
    }
    if (levels.length === 0)
        return { levels: [] };
    const recommendedRaw = input.platformDefault ?? input.vendorDefault;
    const recommendedSource = input.platformDefault
        ? "platform"
        : input.vendorDefault ? "vendor" : undefined;
    const recommended = recommendedRaw ? nearestSupportedEffort(recommendedRaw, levels) : undefined;
    const employeeChoice = input.employeeChoice ? nearestSupportedEffort(input.employeeChoice, levels) : undefined;
    return {
        levels,
        ...(recommended ? { recommended, recommendedSource } : {}),
        ...(employeeChoice ? { employeeChoice } : {}),
        ...((employeeChoice ?? recommended) ? { effective: employeeChoice ?? recommended } : {}),
    };
}
//# sourceMappingURL=model-effort-spec.js.map